import { render } from "./MarketPriceGauge.vue?vue&type=template&id=60ef31e1&scoped=true"
import script from "./MarketPriceGauge.vue?vue&type=script&lang=js"
export * from "./MarketPriceGauge.vue?vue&type=script&lang=js"

import "./MarketPriceGauge.vue?vue&type=style&index=0&id=60ef31e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ef31e1"]])

export default __exports__